<template>
    <v-container>

        <div class="text-xs-center pt-2">
            <h2>Όροι και Προϋποθέσεις</h2>
            <hr/>
        </div>

        <h3>Δηλώνω υπεύθυνα ότι:</h3>
        <v-checkbox
                @change="checkedChange(1)"
                required
                v-model="checkedTerms"
                aria-label="Έχω διαβάσει και αποδέχομαι τους όρους και προϋποθέσεις">
            <div slot="label">Έχω διαβάσει και αποδέχομαι τους <a href="https://eudoxus.gr/Files/Terms_and_Conditions_Plus.pdf" target="_blank">όρους και προϋποθέσεις</a>
            </div>
        </v-checkbox>
        <v-checkbox v-if="renderSecondCheckbox() "
                @change="checkedChange(2)"
                label="Παρακολουθώ μαθήματα για τη λήψη πρώτου ή δεύτερου πτυχίου προπτυχιακών σπουδών."
                v-model="checkedDegree"
        ></v-checkbox>

        <v-btn :disabled="!checkedTerms"
               @click="chooseDialogs"
               color="primary"
               dark
               round>
            <span class="editButton">Υποβολή</span>
            <v-icon>done_all</v-icon>
        </v-btn>

        <v-dialog max-width="500" persistent v-model="certificateDialog" @keydown.esc="certificateDialog = false">
            <v-card>
                <v-card-title class="error white--text headline justify-center"><b>Προσοχή</b></v-card-title>
                <v-card-text>Δηλώσατε ότι παρακολουθείτε μαθήματα για τη λήψη τρίτου ή ανωτέρου πτυχίου προπτυχιακών
                    σπουδών.
                    Οι φοιτητές που δεν παρακολουθούν μαθήματα για τη λήψη πρώτου ή δεύτερου πτυχίου προπτυχιακών
                    σπουδών δεν δικαιούνται δωρεάν διανομής συγγραμμάτων.
                    Σε αυτή την περίπτωση θα έχετε τη δυνατότητα παραλαβής συγγραμμάτων μόνο μέσω Ανταλλαγής (Εύδοξος+).
                    <br/><b>Είστε σίγουρος/η ότι θέλετε να συνεχίσετε;</b></v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="certificateDialogRoute(true)" color="primary darken-0" flat>Συνέχεια</v-btn>
                    <v-btn @click.native="certificateDialogRoute(false)" color="primary darken-0" >Ακύρωση</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog max-width="500" persistent v-model="exchangeDialog" @keydown.esc="exchangeDialog = false">
            <v-card>
                <v-card-title class="secondary white--text headline justify-center"><b>Διάθεση Συγγραμμάτων</b></v-card-title>
                <v-card-text>Θέλετε να δηλώσετε για ανταλλαγή κάποιο από τα παλαιότερα συγγράμματά σας;</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="exchangeDialogRoute(false)" color="primary darken-0" flat>Όχι</v-btn>
                    <v-btn @click.native="exchangeDialogRoute(true)" color="primary darken-0" >Ναι</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-container>
</template>

<script>

    import {mapActions, mapState} from 'vuex';
    import requests from "../../requests";
    import utils from "../../utilities";

    export default {
        name: "TermConditionsComponent",
        data() {
            return {
                semesterCoursesArray: [],
                semesterArray: [],
                requestFlag: false,
                coursesArrayId: [],
                checkedTerms: false,
                checkedDegree: false,
                certificateDialog: false,
                exchangeDialog: false,
                department:false,
                courses:false,
                booksGroups:false,
                utils
            }
        },
        computed: {
            ...mapActions({}),

            ...mapState([
                'eudoxusTitle'
            ]),
            /*checkeResponse: function () { this causes "maximum call stack size exceeded"
                return this.checkeResponse()
            }*/
        },
        methods: {

            renderSecondCheckbox(){

                return this.$store.getters.login.hasAcceptedSecondTerm ? false : !utils.isNPlus2OrKatataktirios();
            },

            checkedChange(id) {
                var active = this.$store.getters.active;
                if (id == 1) {
                    if (this.checkedTerms) {
                        this.$store.commit('setCheckedTerms', true);
                        active.hasAcceptedTerms = true;
                        this.$store.commit('setActive', active);
                    }
                    else {
                        this.$store.commit('setCheckedTerms', false);
                    }
                }

                if (id == 2) {
                    if (this.checkedDegree) {
                        active.inArrangementsBlackList = false;
                        this.$store.commit('setActive', active);
                        this.$store.commit('setCheckedDegree', true);
                    }
                    else {
                        active.inArrangementsBlackList = true;
                        this.$store.commit('setActive', active);
                        this.$store.commit('setCheckedDegree', false);
                    }
                }
            },

            chooseDialogs() {
                if (utils.isNPlus2OrKatataktirios()) {
                    semesterData = [];
                    this.$store.commit('setSemesterData', semesterData);
                    this.exchangeDialog = true;
                }
                else {
                    var semesterData = this.$store.getters.semesterData;
                    if (this.checkedTerms && !this.checkedDegree)
                        this.certificateDialog = true;
                    else if (this.checkedTerms && this.checkedDegree) {
                        semesterData = [];
                        this.$store.commit('setSemesterData', semesterData);
                        this.exchangeDialog = true;
                    }
                }

                this.submission();
            },

            exchangeDialogRoute(flag) {
                if (flag){
                    this.$router.push({path: '/bookExchange'});
                }
                else {
                    this.$store.commit('setLoadingModal', true);
                    this.$router.push({path: '/newStudentBookList'});
                }

                this.exchangeDialog = false;
            },

            certificateDialogRoute(flag) {
                if (flag)
                    this.exchangeDialog = true;
                this.certificateDialog = false;
            },

            successSelectedDepartment(response){
                var setLinkedSemesterData = {};
                for (var i=0; i < response.length;i++){
                    setLinkedSemesterData[response[i].secretariatId] = null;
                    response[i].message = ""
                }
                this.$store.commit('setLinkedSemesterData', setLinkedSemesterData);
                this.$store.commit('setSelected', response);
            },

            async submission() {
                requests.selectedDepartment(this.successSelectedDepartment);
                requests.allCourses(this.$store.getters.login.secretariat.id, this.createCoursesArrayId);
                requests.allBooksGroupByCourse(this.$store.getters.login.secretariat.id, this.createListOfBooksById);
            },

            createCoursesArrayId(response) {
                for (let i = 0; i < response.data.length; i++) {
                    this.coursesArrayId[i] = response.data[i].id;
                }

                this.$store.commit('setCourses', response.data);
                this.$store.commit('setSemesters', utils.getSemestersFromActive(response.data, this.$store.getters.login.statementMaxCourseSemester));
                requests.freebookCourses(this.coursesArrayId, this.createListOfEbooksById)
            },

            createListOfBooksById(response) {
                    this.$store.commit('setListOfBooksById', utils.checkIfBookIsActiveFromSecretary(response));
                    this.createListSemesterData();
            },

            createListOfEbooksById(response) {
                this.$store.commit('setListOfEbooksById', response);
            },

            createListSemesterData() {
                this.semesterCoursesArray = utils.createSemesterCoursesArray(this.$store.getters.courses, this.$store.getters.semesters);
                this.finalCoursesData()
            },

            finalCoursesData() {
                var semesterData = utils.getSemesterData(this.$store.getters.listOfBooksById, this.semesterCoursesArray, null);
                if (semesterData.length == 0) {
                    semesterData = [null];
                }
                this.$store.commit('setSemesterData', semesterData);
            },
            initCheckedDegreeInTrue() {
                if (this.$store.getters.login.hasAcceptedSecondTerm) {
                    this.checkedDegree = true;
                    this.$store.commit('setCheckedTerms', true);
                    active.hasAcceptedTerms = true;
                    this.$store.commit('setActive', active);
                } else {
                    var active = this.$store.getters.active;
                    active.inArrangementsBlackList = true;
                    this.$store.commit('setActive', active);
                    this.$store.commit('setCheckedDegree', false);
                }
            }
        },
        created() {
            this.initCheckedDegreeInTrue();

        }
    }
</script>

<style scoped>
    .editButton {
        font-size: small;
        padding-right: 5px;
    }
</style>
